<template>
	<div :class="['motion-ribbon', `ribbon-${tone}`, { 'is-reverse': reverse }]" :aria-label="label">
		<div class="motion-ribbon-track" aria-hidden="true">
			<!-- 8 copies: the track loops at -50%, so each half (4 copies) must cover ultrawide screens -->
			<span v-for="i in 8" :key="i">
				<template v-for="word in words" :key="word">{{ word }}<component :is="icon" class="ribbon-mark" :size="26" :stroke-width="iconStroke" /></template>
			</span>
		</div>
	</div>
</template>

<script setup>
import { Asterisk } from "lucide-vue-next";

defineProps({
	words: { type: Array, required: true },
	/** Accessible summary of the scrolling words */
	label: { type: String, required: true },
	/** orange or ink */
	tone: { type: String, default: "orange" },
	/** Separator icon (an SVG, never the ✳ character, which iOS shows as a green emoji) */
	icon: { type: [Object, Function], default: () => Asterisk },
	iconStroke: { type: Number, default: 3 },
	/** Scroll left to right */
	reverse: { type: Boolean, default: false }
});
</script>
